import React, { useEffect, useState } from "react";
import { useNavigate, useLocation, useOutletContext } from "react-router-dom";
import PageTitle from "../../../components/partials/PageTitle";
import { useSelector } from "react-redux";
import { isEmptyObject } from "./../../../utils/validators/validators";
import useInputChange from "./../../../utils/hooks/useInputChange";
import Form from "../../../components/form/Form";
import { useDispatch } from "react-redux/es/exports";
import {
  addStaffWorkExperience,
  resetStaffStatus,
} from "./../../../redux/slice/staff/staffSlice";
import PhoneInput from "react-phone-number-input";

const AddWorkExperience = () => {
  const [reasonTextField, setReasonTextField] = useState(false);
  const [hasWorkExperience, setHasWorkExperience] = useState(false);

  const [error, setError] = useState({});
  const { user_permissions } = useSelector((state) => state.auth?.user);
  const { app_id, staff_records, pages, isSuccess, isLoading, isError } =
    useSelector((state) => state.staff);
  const { nextPage } = useOutletContext();

  const [staffInputData, setStaffInputData] = useState({
    company_name: "Nill",
    job_description: "Nill",
    company_address: "Nill",
    reporting_officer_number: "Nill",
    object_status: "Nill",
    verify_reasons: "Nill",
    app_id: app_id,
  });

  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const [input, handleChange] = useInputChange(
    staffInputData,
    setStaffInputData,
    error,
    setError
  );

  const [phoneNumber, setPhoneNumber] = useState("");
  const [borderColor, setBorderColor] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const handlePhoneNumberChange = (phone_no) => {
    if (!phone_no) {
      setBorderColor("#fa5c7c");
      setErrorMessage("Please enter phone number");
    } else {
      setBorderColor("");
      setErrorMessage("");

      setPhoneNumber(phone_no);
    }
    setStaffInputData({
      ...staffInputData,
      reporting_officer_number: phoneNumber,
    });
  };

  const updateStaffInputData = () => {
    if (hasWorkExperience) {
      setStaffInputData({
        company_name: "",
        job_description: "",
        company_address: "",
        reporting_officer_number: "",
        object_status: "",
        verify_reasons: "",
        app_id: app_id,
      });
    } else if (!hasWorkExperience) {
      setStaffInputData({
        company_name: "Nill",
        job_description: "Nill",
        company_address: "Nill",
        reporting_officer_number: "Nill",
        object_status: "Nill",
        verify_reasons: "Nill",
        app_id: app_id,
      });
    }
  };

  // Form submit handler
  const handleSubmit = () => {
    if (isEmptyObject(error)) {
      if (!phoneNumber && hasWorkExperience) {
        setBorderColor("");
        setErrorMessage("Please enter phone number");
        return;
      }
      dispatch(
        addStaffWorkExperience({
          ...staffInputData,
          reporting_officer_number: phoneNumber,
        })
      );
    }
  };

  // reset erro state handler
  const resetError = () => {
    setError({});
  };

  const breadcrumb = {
    from: {
      title: "Add Staff",
      link: "/admin/add-staff",
    },
    current: {
      title: "work experience",
      link: null,
    },
  };

  // staff registration middlware
  useEffect(() => {
    !app_id
      ? navigate(-1)
      : nextPage &&
        navigate(nextPage, { state: { from: location }, replace: true });
  }, [pages]);

  // isForm Submitted Successfully = true => navigate to next route
  useEffect(() => {
    if (isSuccess) {
      navigate("/admin/add-staff/next-of-kin-information", {
        state: { from: location },
        replace: true,
      });
    }
    return () => {
      dispatch(resetStaffStatus());
    };
  }, [staff_records, isError, isSuccess, isLoading]);

  // Reset error state
  useEffect(() => {
    updateStaffInputData();
    resetError();
    setBorderColor("");
    setErrorMessage("");
  }, [hasWorkExperience]);

  useEffect(() => {
    if (
      !user_permissions?.some(
        (permission) => permission.name === "staff module"
      ) ||
      !user_permissions?.some(
        (permission) => permission.name === "create staff"
      )
    ) {
      navigate("/admin/dashboard");
    }
  }, [navigate, user_permissions]);
  return (
    <>
      {/* page title */}
      <PageTitle title='Staff Creation' breadcrumb={breadcrumb} />
      {/* end page title */}

      {/* content */}
      <div className='row'>
        <div className='col-md-12'>
          <div className='card'>
            <div className='card-body'>
              <div className='row pb-2 mb-3 text-capitalize border-bottom'>
                <div className='col-md-12 d-flex justify-content-between align-items-center'>
                  <h4 className='header-title text-uppercase mb-0 text-primary'>
                    Previous Work Information
                  </h4>
                </div>
              </div>
              <div className='flex'>
                <div className='d-flex gap-2'>
                  <label htmlFor='verify' className='form-label'>
                    Do you have work experience?
                  </label>
                  <div className=''>
                    <input
                      type='checkbox'
                      id='switch80'
                      data-switch='secondary'
                      value=''
                    />
                    <label
                      onClick={() => {
                        setHasWorkExperience(!hasWorkExperience);
                      }}
                      htmlFor='switch80'
                      data-on-label='Yes'
                      data-off-label='No'
                      className='mx-lg-2'
                    ></label>
                  </div>
                </div>
              </div>
              {hasWorkExperience && (
                <Form
                  setError={(e) => {
                    if (!phoneNumber) {
                      setBorderColor("#fa5c7c");
                      setErrorMessage("phone number is required.");
                    }
                    setError(e);
                  }}
                  submitHandler={handleSubmit}
                  values={staffInputData}
                >
                  <div className='row g-'>
                    <div className='mb-0 col-md-6'>
                      <label htmlFor='inputEmail4' className='form-label'>
                        Company Name
                      </label>
                      <input
                        textname='company name'
                        name='company_name'
                        onChange={handleChange}
                        value={input.company_name}
                        type='company_name'
                        className={`form-control ${
                          error.company_name && "is-invalid"
                        }`}
                        id='inputEmail4'
                        placeholder='Company Name'
                      />
                      {error.company_name && (
                        <span className='invalid-feedback'>
                          {error.company_name}
                        </span>
                      )}
                    </div>

                    <div className='mb-0 col-md-6'>
                      <label htmlFor='inputEmail4' className='form-label'>
                        Job Description
                      </label>
                      <input
                        textname='job description'
                        name='job_description'
                        onChange={handleChange}
                        value={input.job_description}
                        type='text'
                        className={`form-control ${
                          error.job_description && "is-invalid"
                        }`}
                        id='inputEmail4'
                        placeholder='Job Description'
                      />
                      {error.job_description && (
                        <span className='invalid-feedback'>
                          {error.job_description}
                        </span>
                      )}
                    </div>
                  </div>

                  <div className='row g-2'>
                    <div className='mb-3 mt-4'>
                      <label htmlFor='contact_address' className='form-label'>
                        Company Address
                      </label>
                      <textarea
                        textname='company address'
                        name='company_address'
                        onChange={handleChange}
                        value={input.company_address}
                        id='company_address'
                        className={`form-control ${
                          error.company_address && "is-invalid"
                        }`}
                        rows='6'
                        placeholder='Enter address here'
                      ></textarea>
                      {error.company_address && (
                        <span className='invalid-feedback'>
                          {error.company_address}
                        </span>
                      )}
                    </div>
                  </div>

                  <div className='row g-2'>
                    <div className='col-md-12 mb-3'>
                      <label htmlFor='contact_address' className='form-label'>
                        Reporting Officer Number
                      </label>
                      <PhoneInput
                        placeholder='Enter phone number'
                        value={phoneNumber}
                        onChange={handlePhoneNumberChange}
                        onBlur={(e) => {
                          if (!e.target.value) {
                            setBorderColor("#fa5c7c");
                            setErrorMessage("phone number is required.");
                          } else {
                            setBorderColor("");
                            setErrorMessage("");
                          }
                        }}
                        defaultCountry='NG'
                        className='form-control custom-phone-input'
                        style={{ borderColor: `${borderColor}` }}
                      />
                      {errorMessage && (
                        <span
                          className='text-danger'
                          style={{ fontSize: "12px" }}
                        >
                          {errorMessage}
                        </span>
                      )}
                    </div>
                  </div>

                  <div className='row g-2'>
                    <div className='col-md-12 mb-3'>
                      <div className='d-flex gap-2'>
                        <label htmlFor='verify' className='form-label'>
                          Do you object us to verify your details
                        </label>
                        <div className=''>
                          {/* <!-- Dark Switch--> */}
                          <input
                            textname='answer'
                            name='object_status'
                            // value={reasonTextField ? 'Yes' : 'No'}
                            value={input.object_status}
                            onChange={handleChange}
                            className={`form-control ${
                              error.object_status && "is-invalid"
                            }`}
                            type='checkbox'
                            id='switch8'
                            data-switch='secondary'
                          />
                          <label
                            htmlFor='switch8'
                            data-on-label='No'
                            data-off-label='Yes'
                            className='mx-lg-2'
                            onClick={() => {
                              setReasonTextField(!reasonTextField);
                            }}
                          ></label>
                          {error.object_status && (
                            <span className='invalid-feedback'>
                              {error.object_status}
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>

                  {reasonTextField && (
                    <div className='row g-2'>
                      <div className='mb-3'>
                        <label htmlFor='contact_address' className='form-label'>
                          If yes give reasons
                        </label>
                        <textarea
                          textname='reasons'
                          name='verify_reasons'
                          value={input.verify_reasons}
                          onChange={handleChange}
                          id='company_address'
                          className={`form-control ${
                            error.verify_reasons && "is-invalid"
                          }`}
                          rows='6'
                          placeholder='Please state reasons'
                        ></textarea>
                        {error.verify_reasons && (
                          <span className='invalid-feedback'>
                            {error.verify_reasons}
                          </span>
                        )}
                      </div>
                    </div>
                  )}

                  <div className='d-flex float-end gap-2'>
                    {/* <div className="">
                                        <button className="btn btn-info w-10 px-3">Skip</button>
                                    </div> */}
                    <div className='float-end'>
                      <button
                        disabled={isLoading && true}
                        className='btn btn-primary w-10'
                      >
                        Proceed
                      </button>
                    </div>
                  </div>
                </Form>
              )}
              {!hasWorkExperience && (
                <div className='float-end'>
                  <button
                    disabled={isLoading && true}
                    className='btn btn-primary w-10'
                    onClick={() => {
                      if (!phoneNumber) {
                        setBorderColor("#fa5c7c");
                        setErrorMessage("phone number is required.");
                      }
                      handleSubmit();
                    }}
                  >
                    Proceed
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      {/* end content */}
    </>
  );
};

export default AddWorkExperience;
